import { Navigate,Outlet } from "react-router-dom";
import { isAuthenticated } from "../App";

const useAuth = () => {
  const user = localStorage.getItem("token");
  if (user) {
    return true;
  } else {
    return false;
  }
};

const PrivateRoutes = () => {
  const auth = useAuth();
  return isAuthenticated() && auth ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoutes;
